import sum from 'root-core/utils/array/sum.js'
import effectiveDiscount from './effectiveDiscount.js'
import * as priceDiscounts from './priceDiscounts.js'

export function price (passengers) {
  var frequentTravellerDiscountAmount = sum(
    passengers.map(p => (p.discounts.frequentTravellerDiscount && p.frequentTravellerDiscountAmount) || 0)
  )
  var frequentTravellerAdults = passengers.filter(
    p => p.type == 'adult' && p.discounts.frequentTravellerDiscount
  ).length
  var frequentTravellerChildren = passengers.filter(
    p => p.type == 'child' && p.discounts.frequentTravellerDiscount
  ).length

  if (frequentTravellerDiscountAmount > 0) {
    return {
      name: 'Frequent Traveller Discount',
      amount: frequentTravellerDiscountAmount,
      adults: frequentTravellerAdults,
      children: frequentTravellerChildren,
    }
  }
}

export function applicableFrequentTravellerDiscount (departure, bookingDate) {
  if (departure.ftdActive) {
    return priceDiscounts.mostRecentlyCreatedDiscount(
      (departure.prices.adjustments.discounts.frequentTravellerDiscounts || []).filter(discount =>
        effectiveDiscount({discount, bookingDate})
      )
    )
  }
}
